import { render } from "./awaedList.vue?vue&type=template&id=bfc040c4&scoped=true"
import script from "./awaedList.vue?vue&type=script&lang=js"
export * from "./awaedList.vue?vue&type=script&lang=js"

import "./awaedList.vue?vue&type=style&index=0&id=bfc040c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfc040c4"]])

export default __exports__